import { Col, Row } from 'react-bootstrap';
import ResetPasswordForm from '../components/admin/clients/resetPassword/ResetPasswordForm';
import AdminLayout from './layout/AdminLayout';

const ResetPassword = () => {

    return (
        <AdminLayout>
            <Row>
                <Col>
                    <h1 className="title" style={{textAlign: 'center'}}>Reset Password</h1><br />
                    <ResetPasswordForm />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default ResetPassword;